export default __webpack_public_path__ + "resources/icons/d232-5516.png";